import { Box, Card, CardContent } from '@mui/material'
import { useTranslation } from 'react-i18next'
import {
  useReleaseCheckStatus,
  useStartReleaseCheckCategoryRun,
} from '../../api/release-check-api'
import { CheckCategory } from '../../types/ReleaseCheckItem'
import CategoryRow, { isRunningState } from './CategoryRow'
import ResultsTable from './ResultsTable'

interface CategoryPanelProps {
  category: CheckCategory
}

const CategoryPanel = ({ category }: CategoryPanelProps) => {
  const { t } = useTranslation()
  const [status] = useReleaseCheckStatus()
  const [startCategory, isStartingCategory, startingCategory] = useStartReleaseCheckCategoryRun()

  const umbrellaRunning = isRunningState(status?.state)

  const confirmAndForceCategory = (c: CheckCategory) => {
    if (!window.confirm(t('releaseCheck.confirmRestart.bodyCategory', 'This will terminate the running scan for this category and start a fresh one. Continue?'))) return
    void startCategory({ category: c, force: true })
  }

  return (
    <Box>
      <Card sx={{ border: 1, borderColor: 'divider', mb: 2 }}>
        <CardContent>
          <CategoryRow
            category={category}
            status={status?.categories?.[category]}
            umbrellaRunning={umbrellaRunning}
            onRescan={(c) => void startCategory({ category: c })}
            onForceRestart={confirmAndForceCategory}
            isStarting={isStartingCategory}
            startingCategory={startingCategory}
          />
        </CardContent>
      </Card>
      <ResultsTable category={category} />
    </Box>
  )
}

export default CategoryPanel
